import { render, staticRenderFns } from "./PlansPartner.vue?vue&type=template&id=8be5184e&scoped=true&"
import script from "./PlansPartner.vue?vue&type=script&lang=js&"
export * from "./PlansPartner.vue?vue&type=script&lang=js&"
import style0 from "./PlansPartner.vue?vue&type=style&index=0&lang=stylus&"
import style1 from "./PlansPartner.vue?vue&type=style&index=1&id=8be5184e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8be5184e",
  null
  
)

export default component.exports